export enum UserRole {
  CUSTOMER_SUPPORT_ADMIN_WSC = 'CUSTOMER_SUPPORT_ADMIN_WSC',
  ADMIN_DIGITAL_PRODUCT_WSC = 'ADMIN_DIGITAL_PRODUCT_WSC',
  USER = 'USER',
  ADMIN_WSC_PRODUCT = 'ADMIN_WSC_PRODUCT',
  IDENTITY_MANAGER = 'IDENTITY_MANAGER',
  PROCUREMENT_WSC = 'PROCUREMENT_WSC',
  SUPPLIER_WSC = 'SUPPLIER_WSC',

  ORDER_DATA_HUB_ORDER_ENTRY = 'ORDER_DATA_HUB_ORDER_ENTRY',
}

const ALLOWED_ROLES = [
  UserRole.ADMIN_DIGITAL_PRODUCT_WSC,
  UserRole.ADMIN_WSC_PRODUCT,
  UserRole.CUSTOMER_SUPPORT_ADMIN_WSC,
  UserRole.IDENTITY_MANAGER,
  UserRole.USER,
  UserRole.PROCUREMENT_WSC,
  UserRole.SUPPLIER_WSC,
];

export const isAnyAdminRole = (role: string) => {
  return (
    role === UserRole.ADMIN_DIGITAL_PRODUCT_WSC ||
    role === UserRole.CUSTOMER_SUPPORT_ADMIN_WSC ||
    role === UserRole.ADMIN_WSC_PRODUCT ||
    role === UserRole.IDENTITY_MANAGER
  );
};

export const isUserAccessAllowed = (roles: string[]) => {
  return roles?.some((role) => ALLOWED_ROLES.includes(UserRole[role]));
};

export const isAnyAdminUser = (roles: string[]) => {
  return roles?.some(isAnyAdminRole);
};

export const isDigitalProductAdminUser = (roles: string[]) => {
  return roles?.includes(UserRole.ADMIN_DIGITAL_PRODUCT_WSC);
};

export const isSales = (roles: string[]) => {
  return roles?.includes(UserRole.CUSTOMER_SUPPORT_ADMIN_WSC);
};

export const isAdminOrSales = (roles: string[]) => {
  return roles?.some(
    (role) =>
      role === UserRole.CUSTOMER_SUPPORT_ADMIN_WSC || role === UserRole.ADMIN_DIGITAL_PRODUCT_WSC,
  );
};

export const canCreateSapOffer = (roles: string[]) => {
  return roles?.some(
    (role) =>
      role === UserRole.ORDER_DATA_HUB_ORDER_ENTRY || role === UserRole.ADMIN_DIGITAL_PRODUCT_WSC,
  );
};
